import React from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useTranslation } from "react-i18next"
import HousingTable from "./HousingTable"

export default function HousingList() {
  const { t } = useTranslation()

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="" breadcrumbItem={t("Housing")} />
        <HousingTable />
      </div>
    </div>
  )
}
